export default "__VITE_ASSET__C5ag23AL__"